import React, { useCallback } from 'react';
import c from 'classnames';

import './style.scss';

// Illustrations
import { ReactComponent as Groeien } from '../../../assets/images/illustrations/primary/groeien.svg';
import { ReactComponent as Hersenen } from '../../../assets/images/illustrations/primary/hersenen.svg';
import { ReactComponent as Route } from '../../../assets/images/illustrations/primary/route.svg';
import { ReactComponent as Vergrootglas } from '../../../assets/images/illustrations/primary/vergrootglas.svg';
import { ReactComponent as Handdruk } from '../../../assets/images/illustrations/primary/handdruk.svg';
import { ReactComponent as Gesprek } from '../../../assets/images/illustrations/primary/gesprek.svg';
import { ReactComponent as Informatie } from '../../../assets/images/illustrations/primary/informatie.svg';
import { ReactComponent as Verbinding } from '../../../assets/images/illustrations/primary/verbinding.svg';

type SVGIllustration = React.FC<React.SVGProps<SVGSVGElement>>;

const illustrations = {
  groeien: Groeien,
  hersenen: Hersenen,
  route: Route,
  vergrootglas: Vergrootglas,
  handdruk: Handdruk,
  gesprek: Gesprek,
  informatie: Informatie,
  verbinding: Verbinding,
};

const HomepageHeroIllustrations: React.FC = () => {
  const renderIllustration = useCallback(([name, Illustration]: [string, SVGIllustration]) => {
    const className = c('HomepageHeroIllustrations__illustration', `HomepageHeroIllustrations__illustration--${name}`);

    return (
      <Illustration className={className} />
    );
  }, []);

  return (
    <div className="HomepageHeroIllustrations">
      <div className="HomepageHeroIllustrations--left">
        {Object.entries(illustrations).slice(0, 4).map(renderIllustration)}
      </div>

      <div className="HomepageHeroIllustrations--right">
        {Object.entries(illustrations).slice(4, 8).map(renderIllustration)}
      </div>
    </div>
  );
};

export default HomepageHeroIllustrations;
